module.exports = __webpack_public_path__ + "static/12-c41d6ba6afccdb25912668b51bd718de.jpeg";